export const indicationLink = {
  title: 'Indication link',
  description:
    'refer and earn matchcoins by bringing your friends to play with you'
};
